import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39128f17"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-magic-line c-magic-line--underline whitespace-nowrap text-dusty-grey" }
const _hoisted_2 = { class: "px-x3 sm:px-x4" }
const _hoisted_3 = { class: "text-center -mt-10 mb-x2 md:mb-x3" }
const _hoisted_4 = { class: "min-h-320" }

import { computed } from 'vue';
import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import useProductComposingOverlay from '@/shared/product/details/useProductComposingOverlay';
import Swiper from '@/shared/Swiper.vue';
import ProductDetailUpsellItem from '@/shared/product/upsell/ui/ProductDetailUpsellItem.vue';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductConfigurableModulesOverlay',
  props: {
    productId: null,
    configurationId: { default: undefined },
    showAddToBasket: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { productId: number, configurationId: string, showAddToBasket: boolean }



const { showComposingModules, closeComposingModules, shouldShowConfigurationModulesDialog, productComposingModules } = useProductComposingOverlay();

const isMobile = computed(() => breakpointsState.activeBreakpoint === 'xs');
const isTablet = computed(() => breakpointsState.activeBreakpoint === 'sm');
const freeMode = computed(() => isMobile.value || isTablet.value);

const labels = useBlockLabels();

function handleClickShowComposingModules() {
    showComposingModules(props.productId, props.configurationId);
}

function handleCloseComposingModules() {
    closeComposingModules();
}

const swiperOptions = computed(() => {
    let slidesPerView = 3.6;
    if (isMobile.value) {
        slidesPerView = 1.8;
    } else if (isTablet.value) {
        slidesPerView = 2.8;
    }
    return {
        spaceBetween: 18,
        centerInsufficientSlides: true,
        slidesPerGroup: 3,
        slidesOffsetBefore: 25,
        slidesOffsetAfter: 25,
        slidesPerView,
    };
});


return (_ctx: any,_cache: any) => {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      type: "button",
      class: "my-10",
      onClick: handleClickShowComposingModules
    }, [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(labels).showComposingModulesBtnText), 1)
    ]),
    _createVNode(BaseDialog, {
      class: "fixed inset-0 py-x4 mx-auto z-1 bg-white max-w-925 pt-60 sm:relative sm:inset-auto sm:w-screen-90 sm:h-auto md:w-screen-80",
      "is-open": _unref(shouldShowConfigurationModulesDialog),
      onClose: handleCloseComposingModules
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(labels).composingModulesDialogTitle), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Swiper, {
              "free-mode": _unref(freeMode),
              options: _unref(swiperOptions),
              class: _normalizeClass({ swiper: !_unref(freeMode) })
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productComposingModules), (item, idx) => {
                  return (_openBlock(), _createBlock(_component_SwiperSlide, {
                    key: item.sku+idx,
                    class: "swiper-item min-h-320"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ProductDetailUpsellItem, {
                        item: item,
                        "show-add-to-basket": __props.showAddToBasket
                      }, null, 8, ["item", "show-add-to-basket"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["free-mode", "options", "class"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["is-open"])
  ]))
}
}

})